import React from "react";
import "./App.css";
import Redoc from "./components/Redoc";
import MarkdownRenderer from "./components/MarkdownRenderer";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import GoogleForm from "./components/GoogleForm";

function App() {
  const getFilePath = (baseName, extension = "md") => {
    return `/${baseName}.${process.env.REACT_APP_ENV || "prod"}.${extension}`;
  };
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route
            exact
            path="/"
            element={<MarkdownRenderer path={getFilePath("README")} />}
          />
          <Route
            path="/documentation"
            exact
            element={<Redoc specUrl={getFilePath("endpoints", "yaml")} />}
          ></Route>
          <Route
            path="/internal"
            exact
            element={
              <Redoc specUrl={getFilePath("endpoints.internal", "yaml")} />
            }
          ></Route>
          <Route path="/requestaccess" exact element={<GoogleForm />}></Route>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
